import CardCheckout from './CardCheckout';

export default CardCheckout;
